import { useRef, useState } from 'react'

const RECENTLY_COPIED_FEEDBACK_DURATION_MS = 1500

export interface RecentlyCopiedFeedback {
  readonly didRecentlyCopy: boolean
  readonly isTooltipOpen: boolean
  readonly markCopied: () => void
  readonly setIsTooltipOpen: (isOpen: boolean) => void
}

export function useRecentlyCopiedFeedback(
  durationMs = RECENTLY_COPIED_FEEDBACK_DURATION_MS,
): RecentlyCopiedFeedback {
  const [state, setState] = useState({
    didRecentlyCopy: false,
    isOpen: false,
  })
  const clearFeedbackTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  )

  return {
    didRecentlyCopy: state.didRecentlyCopy,
    isTooltipOpen: state.isOpen === true || state.didRecentlyCopy === true,
    markCopied: () => {
      if (clearFeedbackTimeoutRef.current !== null) {
        clearTimeout(clearFeedbackTimeoutRef.current)
      }

      setState({
        didRecentlyCopy: true,
        isOpen: true,
      })
      clearFeedbackTimeoutRef.current = setTimeout(() => {
        clearFeedbackTimeoutRef.current = null
        setState({
          didRecentlyCopy: false,
          isOpen: false,
        })
      }, durationMs)
    },
    setIsTooltipOpen: (isOpen) => {
      setState((previous) => {
        return {
          ...previous,
          isOpen,
        }
      })
    },
  }
}
